<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>物料管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="backHref">商品</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!showIsEdit && !showIsAdd && !showIsDetail">
      <section class="searchBox">
        <span class="addStyle">
          <a-button
            @click="showIsAdd = !showIsAdd"
            style="margin-right: 20px"
            type="primary"
            icon="plus"
            >增加</a-button
          >
        </span>
        <span>
          <label>项目：</label>
          <a-select
            v-model="project_id"
            style="width:200px"
            showSearch
            :filterOption="filterOption"
            optionFilterProp="children"
            placeholder="请选择项目"
          >
            <a-select-option
              v-for="(item, i) in proList"
              :key="i"
              :value="item.id"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>状态：</label>
          <a-radio-group v-model="is_upper">
            <a-radio :value="1">下架</a-radio>
            <a-radio :value="2">上架</a-radio>
          </a-radio-group>
        </span>
        <span>
          <label>单位类型：</label>
          <a-radio-group v-model="count_type">
            <a-radio :value="1">单个装</a-radio>
            <a-radio :value="2">整盒装</a-radio>
          </a-radio-group>
        </span>
        <span>
          <label>字符串：</label>
          <a-input
            placeholder="请输入商品名称|商品编号"
            style="width:200px"
            v-model="query_field"
          />
        </span>
        <span>
          <a-button @click="onReset">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="(item, j) in thList" :key="j">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.length < 1">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.project_name }}</td>
              <td>{{ item.brand_name }}</td>
              <td><img :src="item.imageUrl.url_thumb" alt="" /></td>
              <td>
                <p v-show="item.count_type == 1">单个装</p>
                <p v-show="item.count_type == 2">整盒装</p>
              </td>
              <td>
                <p v-show="item.count_type == 2 && item.small_brand_name == ''">
                  未绑定
                </p>
                <p v-show="item.count_type == 2 && item.small_brand_name != ''">
                  {{ item.small_brand_name }}
                </p>
              </td>
              <td>{{ item.price }}</td>
              <td>{{ item.ky_container }}</td>
              <td>
                <p v-show="item.is_upper == 1">下架</p>
                <p v-show="item.is_upper == 2">上架</p>
              </td>
              <td class="operation">
                <a
                  v-show="item.count_type == 2 && item.small_brand_name == ''"
                  @click="goodsRelationDialogs(item)"
                  >绑定关系</a
                >
                <a @click="editPage(item)" style="color:#67C23A">编辑</a>
                <a @click="detailPage(item)" style="color:#777">详情</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- content end -->
    <!-- 增加 -->
    <addGoods v-show="showIsAdd" v-on:hideInAdd="hideInAdd" />
    <!-- 增加 end -->
    <!-- 编辑 -->
    <goodsEdit
      v-show="showIsEdit"
      :editDetail="editDetail"
      v-on:hideInEdit="hideInEdit"
    />
    <!-- 编辑 end -->
    <!-- 详情 -->
    <goodsDetail v-show="showIsDetail" :detailVal="detailVal" />
    <!-- 详情 end -->
    <!-- 绑定关系 -->
    <aside class="dialogsBox" v-show="showIsGoodsRelation">
      <div>
        <h3>绑定关系</h3>
        <a class="close" @click="showIsGoodsRelation = false"
          ><a-icon style="color:#666" type="close-circle"
        /></a>
        <ul>
          <li v-if="goodsRelationDetail != ''">
            <label>商品名称：</label>
            <p>{{ goodsRelationDetail.brand_name }}</p>
          </li>
          <li>
            <label><i>*</i>对应单个：</label>
            <a-select
              style="width:200px"
              showSearch
              :filterOption="filterOption"
              optionFilterProp="children"
              placeholder="请选择商品"
              v-model="small_brand_id"
            >
              <a-select-option
                v-for="(item, i) in goodsList"
                :key="i"
                :value="item.id"
                >{{ item.brand_name }}</a-select-option
              >
            </a-select>
          </li>
        </ul>
        <div>
          <a-button type="primary" @click="submitGoodsRelation">
            提交
          </a-button>
        </div>
      </div>
    </aside>
    <!-- 绑定关系 end -->
  </div>
</template>
<script>
import axios from "axios";
import addGoods from "@/components/equipment/addGoods"; //增加
import goodsEdit from "@/components/equipment/goodsEdit"; //编辑
import goodsDetail from "@/components/equipment/goodsDetail"; //详情
export default {
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: [
        "项目名称",
        "商品名称",
        "图片",
        "单位类型",
        "对应单个",
        "价格/元",
        "货道容量",
        "状态",
        "操作"
      ],
      count_type: "",
      is_upper: "",
      project_id: "",
      query_field: "",
      isHideDetails: false,
      details: {},
      showIsAdd: false,
      proList: [],
      showIsGoodsRelation: false,
      goodsRelationDetail: "",
      goodsList: [],
      small_brand_id: "",
      showIsEdit: false,
      editDetail: "",
      showIsDetail: false,
      detailVal: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    addGoods,
    goodsDetail,
    goodsEdit
  },
  mounted() {
    this.getData(); //获取列表
    this.getGoods(); //获取单个商品
    this.getPro(); //获取项目
  },
  methods: {
    editPage(item) {
      this.showIsEdit = true;
      this.editDetail = item;
    },
    hideInEdit(msg) {
      this.showIsEdit = false;
      if (msg) {
        this.reload();
      }
    },
    submitGoodsRelation() {
      if (this.small_brand_id != "") {
        let url =
          this.httpsBasic.url +
          this.httpsBasic.equipment +
          "Brand_relation/add";
        let params = {
          token: window.localStorage.getItem("xnwfPcToken"),
          big_brand_id: this.goodsRelationDetail.id,
          small_brand_id: this.small_brand_id
        };
        axios.post(url, params).then(res => {
          if (res.data.code == 200) {
            this.$message.success("绑定成功");
            this.showIsGoodsRelation = false;
            this.small_brand_id = "";
            this.reload();
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else {
        this.$message.error("*为必填项");
      }
    },
    getGoods() {
      let url =
        this.httpsBasic.url + this.httpsBasic.equipment + "Brand/getBrandList";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          count_type: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            this.goodsList = res.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          current_page: 1,
          per_page: 10000,
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 2
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    goodsRelationDialogs(item) {
      this.showIsGoodsRelation = true;
      this.goodsRelationDetail = item;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    hideInAdd(msg) {
      this.showIsAdd = false;
      if (msg) {
        this.reload();
      }
    },
    backHref() {
      this.showIsEdit = false;
      this.showIsDetail = false;
      this.showIsAdd = false;
    },
    onChangeDate(date, dateString) {
      this.start_date = dateString[0];
      this.end_date = dateString[1];
      //  console.log(this.searchDate);
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    onReset() {
      this.query_field = "";
      this.project_id = "";
      this.is_upper = "";
      this.count_type = "";
      this.page = 1;
      this.getData();
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      let url = this.httpsBasic.url + this.httpsBasic.equipment + "Brand/lists";
      let params = {
        current_page: this.page,
        per_page: 10,
        query_field: this.query_field,
        project_id: this.project_id,
        is_upper: this.is_upper,
        count_type: this.count_type,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    detailPage(item) {
      this.detailVal = item;
      this.showIsDetail = true;
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  td {
    img {
      height: 30px;
      width: 30px;
      object-fit: cover;
    }
  }
}
</style>
